import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AppState } from '../store/state/appState';
import './TrialRemaining.scss';
import { AppDispatch } from '../store/actions/appDispatch';
import { initializeEngagementUsagePolling } from '../store/actions/engagementsUsageActions';
import { EngagementCallUsageSummary } from '../models/dto/engagementCallUsage';

export default function TrialRemaining() {
	const id = getParsedId(useParams<any>().engagementId);
	const dispatch = useDispatch<AppDispatch>();
	const usage = useSelector<AppState, EngagementCallUsageSummary | nundefined>(s => {
		return id == null ? undefined : s.engagementsUsage.byId.get(id)?.usage;
	});
	
	useEffect(() => {
		if (id != null) {
			dispatch(initializeEngagementUsagePolling(id));
		}
	}, [id]);
	
	if (!usage || (!usage.callCountQuota && !usage.callSecondsQuota))
		return null;
	
	return (
		<React.Fragment>
			<div className="trial-remaining__container">
				<div className="trial-remaining__header">
					Remaining:
				</div>

				{!!usage.callSecondsQuota &&
				<div className="trial-remaining__stat">
					<div>Minutes</div>
					<div className="trial-remaining__stat_count">{getRemaining(usage, 'minutes')}</div>
				</div>
				}

				{!!usage.callSecondsQuota && !!usage.callCountQuota &&
				<div className="trial-remaining__or">or</div>
				}

				{!!usage.callCountQuota &&
				<div className="trial-remaining__stat">
					<div>Calls</div>
					<div className="trial-remaining__stat_count">{getRemaining(usage, 'calls')}</div>
				</div>
				}
			</div>		
		</React.Fragment>
	);
	
	function getParsedId(id: string | nundefined): number | null {
		if (!id || id === 'create')
			return null;
		
		const parsed = parseInt(id);
		return parsed && !isNaN(parsed) ? parsed : null;
	}
	
	function getRemaining(usage: EngagementCallUsageSummary, type: 'minutes' | 'calls'): string {
		let total = type === 'minutes'
				? usage.callSecondsQuota ?? 0
				: usage.callCountQuota ?? 0,
			used = type === 'minutes'
				? usage.callSecondsUsed ?? 0
				: usage.callCountUsed ?? 0,
			remaining = total - used;
		
		if (type === 'minutes') {
			remaining = Math.floor(remaining / 60);
		}
		
		return Math.max(remaining, 0).toLocaleString();
	}
}
